import { z } from "zod";
import { harnessSchema } from "./harness";
import { thinkingLevelSchema } from "./runtime";

export { harnessSchema } from "./harness";

export const agentSchema = z.object({
	id: z.string().uuid(),
	workspaceId: z.string().uuid(),
	name: z.string().min(1).max(255),
	slug: z
		.string()
		.min(1)
		.max(100)
		.regex(/^[a-z0-9-]+$/),
	systemPrompt: z.string(),
	model: z.string(),
	thinkingLevel: thinkingLevelSchema,
	allowedModels: z.array(z.string()).min(1),
	allowedThinkingLevels: z.array(thinkingLevelSchema).min(1),
	tools: z.array(z.string()),
	harness: harnessSchema,
	metadata: z.record(z.unknown()),
	createdAt: z.string().datetime(),
	updatedAt: z.string().datetime(),
});

export type Agent = z.infer<typeof agentSchema>;

/** @deprecated Use agentSchema */
export const profileSchema = agentSchema;
/** @deprecated Use Agent */
export type Profile = Agent;
